import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  ArrowLeft, 
  Settings, 
  Database,
  Package,
  FolderOpen,
  Shield
} from 'lucide-react';
import BackupManager from '../components/BackupManager';
import ProductManager from '../components/ProductManager';
import CategoryManager from '../components/CategoryManager';

function Admin() {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('products');

  const adminSections = [
    {
      id: 'products',
      name: 'Ürün Yönetimi',
      description: 'Ürünleri ekleyin ve düzenleyin',
      icon: Package,
      component: ProductManager
    },
    {
      id: 'categories',
      name: 'Kategori Yönetimi',
      description: 'Ürün kategorilerini yönetin',
      icon: FolderOpen,
      component: CategoryManager
    },
    {
      id: 'backup',
      name: 'Yedekleme',
      description: 'Veri yedekleme ve geri yükleme',
      icon: Database,
      component: BackupManager
    }
  ];

  const ActiveComponent = adminSections.find(section => section.id === activeSection)?.component;

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button
                onClick={() => navigate('/')}
                className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors"
              >
                <ArrowLeft size={20} />
                <span>Ana Sayfa</span>
              </button>
              
              <div className="h-6 w-px bg-gray-300"></div>
              
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-blue-100 rounded-lg">
                  <Shield className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h1 className="text-xl font-bold text-gray-900">Admin Panel</h1>
                  <p className="text-sm text-gray-600">Sistem yönetimi ve özelleştirme</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* Sol Sidebar - Admin Menü */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200">
              <div className="p-4 border-b border-gray-200">
                <h2 className="text-lg font-semibold text-gray-900">Yönetim Araçları</h2>
              </div>
              
              <nav className="p-2">
                {adminSections.map((section) => (
                  <button
                    key={section.id}
                    onClick={() => setActiveSection(section.id)}
                    className={`w-full flex items-center space-x-3 px-3 py-3 rounded-lg text-left transition-all ${
                      activeSection === section.id
                        ? 'bg-blue-50 text-blue-700 border border-blue-200'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    <section.icon 
                      size={20} 
                      className={activeSection === section.id ? 'text-blue-600' : 'text-gray-500'} 
                    />
                    <div className="flex-1">
                      <div className="font-medium">{section.name}</div>
                      <div className="text-xs text-gray-500">{section.description}</div>
                    </div>
                  </button>
                ))}
              </nav>
              
              {/* İstatistikler Kartı */}
              <div className="p-4 border-t border-gray-200">
                <h3 className="text-sm font-medium text-gray-900 mb-3">Sistem Durumu</h3>
                <div className="space-y-2">
                  <div className="flex justify-between items-center text-sm">
                    <span className="text-gray-600">Versiyon</span>
                    <span className="font-medium text-gray-900">v2.0</span>
                  </div>
                  <div className="flex justify-between items-center text-sm">
                    <span className="text-gray-600">Durum</span>
                    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      Aktif
                    </span>
                  </div>
                  <div className="flex justify-between items-center text-sm">
                    <span className="text-gray-600">Son Güncelleme</span>
                    <span className="text-gray-500 text-xs">Bugün</span>
                  </div>
                  <div className="flex justify-between items-center text-sm">
                    <span className="text-gray-600">Özellikler</span>
                    <span className="text-green-600 text-xs font-medium">
                      {adminSections.length} Panel
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Ana İçerik Alanı */}
          <div className="lg:col-span-3">
            {ActiveComponent ? (
              <ActiveComponent />
            ) : (
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                <div className="text-center">
                  <Settings className="mx-auto h-12 w-12 text-gray-400 mb-4" />
                  <h3 className="text-lg font-medium text-gray-900 mb-2">Admin Paneli</h3>
                  <p className="text-gray-600">
                    Sol menüden bir yönetim aracı seçin.
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Admin; 